export const Endpoint = () => `/api/v3/celery/tasklist`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'tasks'] as const;
export type Payload = never;
export type Response = string[];
